export const environment = {
  production: true,
  baseDomain: "sistemabravo.com.ar",
  protocol: "https",
  PUSHER_KEY: "93d5577f5121c814f1d3",
  SENTRY_ENABLED: true,
  SENTRY_DSN: "https://bc22273fe7a495d4f3b22ed06e7e6e2b@o4504577318191104.ingest.us.sentry.io/4508472442617856"
};
